var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgNftPopup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 255,
    viewBox: "0 0 258 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2142 108.859H23.5955C23.9924 106.421 25.0696 103.757 26.8839 100.865C30.5124 95.1387 37.8263 89.5258 44.1196 88.2218V85.8405C41.0013 85.1602 37.9397 83.7427 34.9915 81.645C28.9816 77.3927 24.5593 71.0427 23.5955 65.3164H21.2142C20.6473 68.3213 19.3433 71.2128 17.3022 74.161C13.2767 80.0008 6.98343 84.3097 0.576735 85.8405V88.2218C3.80843 88.9021 7.09682 90.4896 10.3285 92.9276C16.9053 97.8602 20.3638 103.983 21.2142 108.859Z",
    fill: "url(#paint0_linear_2650_65026)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M223.166 65.3143H226.738C227.334 61.6574 228.949 57.6603 231.671 53.323C237.114 44.7335 248.085 36.3141 257.524 34.358V30.7862C252.847 29.7656 248.255 27.6395 243.832 24.4929C234.818 18.1145 228.184 8.58951 226.738 0H223.166C222.316 4.50736 220.36 8.84464 217.298 13.267C211.26 22.0266 201.82 28.49 192.21 30.7862V34.358C197.058 35.3786 201.99 37.7598 206.838 41.4167C216.703 48.8156 221.891 58.0004 223.166 65.3143Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223.166 65.3143H226.738C227.334 61.6574 228.949 57.6603 231.671 53.323C237.114 44.7335 248.085 36.3141 257.524 34.358V30.7862C252.847 29.7656 248.255 27.6395 243.832 24.4929C234.818 18.1145 228.184 8.58951 226.738 0H223.166C222.316 4.50736 220.36 8.84464 217.298 13.267C211.26 22.0266 201.82 28.49 192.21 30.7862V34.358C197.058 35.3786 201.99 37.7598 206.838 41.4167C216.703 48.8156 221.891 58.0004 223.166 65.3143Z",
    fill: "url(#paint1_linear_2650_65026)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.439 94.0742H76.439",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.439 110.574H76.439",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.439 102.574H76.439",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.439 120.574H133.439",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.439 130.574H133.439",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.439 141.574H133.439",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.439 154.574H133.439",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43.939,
    y: 73.0742,
    width: 173.171,
    height: 180.429,
    rx: 6.5,
    stroke: "#737373"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2650_65026",
    x1: 12.5964,
    y1: 65.3164,
    x2: 12.5964,
    y2: 108.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.254728,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836992,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2650_65026",
    x1: 224.867,
    y1: 0,
    x2: 224.867,
    y2: 65.3143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.254728,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836992,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgNftPopup);
export default __webpack_public_path__ + "static/media/bgNftPopup.589f82bd928dab76b886c15ea3f2ae4e.svg";
export { ForwardRef as ReactComponent };